module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_tag_arrow.e6b03.png";